import { render } from "./QA.vue?vue&type=template&id=1a565ae8"
import script from "./QA.vue?vue&type=script&lang=js"
export * from "./QA.vue?vue&type=script&lang=js"
script.render = render

export default script